(() => {
  const key = 'bestekerze:wishlist:v1';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) { return []; }
  };
  const write = (items) => {
    localStorage.setItem(key, JSON.stringify(items));
    refresh();
  };
  const addBusinessDays = (source, amount) => {
    const date = new Date(source);
    let remaining = Number(amount) || 0;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) remaining -= 1;
    }
    return date;
  };
  const refreshDeliveryEstimates = () => {
    const locale = document.documentElement.lang || 'de-DE';
    const formatter = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' });
    document.querySelectorAll('[data-delivery-estimate-slot]').forEach((slot) => {
      const output = slot.querySelector('[data-delivery-estimate]');
      if (!output) return;
      const earliest = addBusinessDays(new Date(), slot.dataset.deliveryMinDays);
      const latest = addBusinessDays(new Date(), slot.dataset.deliveryMaxDays);
      const prefix = window.bestekerzeDelivery?.prefix || 'Bei Bestellung heute voraussichtlich bei dir:';
      output.textContent = `${prefix} ${formatter.format(earliest)}–${formatter.format(latest)}`;
    });
  };
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
  const renderDialog = () => {
    const holder = document.querySelector('[data-wishlist-items]');
    if (!holder) return;
    const items = read();
    holder.innerHTML = items.length ? items.map((item) => `
      <div class="bestekerze-wishlist-item">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '<span></span>'}
        <a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
        <button class="bestekerze-wishlist-remove" type="button" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Entfernen">×</button>
      </div>`).join('') : '<p class="bestekerze-wishlist-empty">Deine Merkliste ist noch leer.</p>';
  };
  const refresh = () => {
    const items = read();
    document.querySelectorAll('[data-wishlist-count]').forEach((element) => { element.textContent = items.length ? String(items.length) : ''; });
    document.querySelectorAll('[data-wishlist-product]').forEach((button) => {
      const saved = items.some((item) => item.handle === button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(saved));
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? window.bestekerzeWishlist?.removeLabel || 'Von Merkliste entfernen' : window.bestekerzeWishlist?.addLabel || 'Zur Merkliste';
    });
    renderDialog();
    refreshDeliveryEstimates();
  };
  document.addEventListener('click', (event) => {
    const productButton = event.target.closest('[data-wishlist-product]');
    if (productButton) {
      const items = read();
      const handle = productButton.dataset.productHandle;
      const index = items.findIndex((item) => item.handle === handle);
      if (index >= 0) items.splice(index, 1);
      else items.push({ handle, title: productButton.dataset.productTitle, url: productButton.dataset.productUrl, image: productButton.dataset.productImage || '' });
      write(items);
      return;
    }
    const trigger = event.target.closest('[data-wishlist-trigger]');
    if (trigger) {
      event.preventDefault();
      renderDialog();
      document.querySelector('[data-wishlist-dialog]')?.showModal();
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) write(read().filter((item) => item.handle !== remove.dataset.wishlistRemove));
    if (event.target.closest('[data-wishlist-close]')) document.querySelector('[data-wishlist-dialog]')?.close();
  });
  const closeNavigation = (root) => {
    root.open = false;
    root.querySelectorAll('details[open]').forEach((topic) => { topic.open = false; });
  };
  let navigationEscapeHandled = false;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const topic = event.target.closest('.bestekerze-nav-topic[open]');
    if (topic) {
      event.preventDefault();
      navigationEscapeHandled = true;
      topic.open = false;
      topic.querySelector('summary')?.focus();
      return;
    }
    const root = event.target.closest('[data-bestekerze-nav-root][open]');
    if (root) {
      event.preventDefault();
      navigationEscapeHandled = true;
      closeNavigation(root);
      root.querySelector('summary')?.focus();
      return;
    }
    document.querySelectorAll('.bestekerze-nav [data-bestekerze-nav-root][open]').forEach(closeNavigation);
  });
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-bestekerze-nav-root] > summary');
    if (summary) {
      const root = summary.parentElement;
      root.closest('ul')?.querySelectorAll('[data-bestekerze-nav-root]').forEach((other) => {
        if (other !== root) closeNavigation(other);
      });
    }
    if (event.target.closest('.js-drawer-close, .bestekerze-nav-choice__panel a')) {
      document.querySelectorAll('[data-bestekerze-nav-root]').forEach(closeNavigation);
    }
    document.querySelectorAll('.bestekerze-nav [data-bestekerze-nav-root][open]').forEach((root) => {
      if (!root.contains(event.target)) closeNavigation(root);
    });
  });
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape' || !navigationEscapeHandled) return;
    event.stopPropagation();
    navigationEscapeHandled = false;
  }, true);
  document.addEventListener('drawerOpen.NavDrawer', () => {
    document.querySelectorAll('.mobile-nav [data-bestekerze-nav-root]').forEach(closeNavigation);
  });
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
